export default function StatusDot(props) {
    let dotColor = 'bg-gray';

    if (typeof props.dataItem[props.field] === 'number') {
        if (props.dataItem[props.field] >= 100) {
            dotColor = 'bg-green';
        }
        else if (props.dataItem[props.field] >= 50) {
            dotColor = 'bg-yellow';
        }
        else {
            dotColor = 'bg-red';
        }
    }
    else if (typeof props.dataItem[props.field] === 'boolean') {
        if (props.dataItem[props.field] === true) {
            dotColor = 'bg-green';
        }
        else {
            dotColor = 'bg-red';
        }
    }

    return (
        <td>
            <div className={ 'dot ' + dotColor }></div>
        </td>
    )
};
